import { NavLink } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

const navItems = [
  { path: "/admin", icon: "ri-dashboard-line", label: "Dashboard" },
  { path: "/admin/services", icon: "ri-service-line", label: "Services" },
  { path: "/admin/solutions", icon: "ri-lightbulb-line", label: "Solutions" },
  { path: "/admin/case-studies", icon: "ri-file-list-3-line", label: "Études de cas" },
  { path: "/admin/testimonials", icon: "ri-chat-quote-line", label: "Témoignages" },
  { path: "/admin/team", icon: "ri-team-line", label: "Équipe" },
  { path: "/admin/partners", icon: "ri-handshake-line", label: "Partenaires" },
  { path: "/admin/blog", icon: "ri-article-line", label: "Blog" },
  { path: "/admin/notifications", icon: "ri-notification-3-line", label: "Notifications" },
  { path: "/admin/newsletter", icon: "ri-mail-send-line", label: "Newsletter" },
  { path: "/admin/users", icon: "ri-user-line", label: "Utilisateurs" },
  { path: "/admin/site-settings", icon: "ri-settings-3-line", label: "Paramètres" },
];

export function AdminSidebar() {
  const { user, logout } = useAuth();

  return (
    <aside className="w-64 min-h-screen bg-gray-900 border-r border-gray-800 flex flex-col">
      <div className="p-6 border-b border-gray-800">
        <NavLink to="/admin" className="flex items-center gap-2">
          <img
            src="https://www.logiqsoft.io/assets/img/logo-blanc.png"
            alt="LogiqSoft"
            className="h-8 w-auto"
          />
          <span className="text-white font-semibold">Admin</span>
        </NavLink>
      </div>

      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === "/admin"}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? "bg-cyan-500/20 text-cyan-400"
                  : "text-gray-400 hover:bg-gray-800 hover:text-white"
              }`
            }
          >
            <i className={`${item.icon} text-lg`} />
            <span className="text-sm font-medium">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-gray-800">
        <div className="px-4 py-2 text-gray-400 text-sm truncate" title={user?.email}>
          {user?.firstName} {user?.lastName}
        </div>
        <button
          onClick={logout}
          className="flex items-center gap-3 w-full px-4 py-3 rounded-lg text-gray-400 hover:bg-red-500/10 hover:text-red-400 transition-colors"
        >
          <i className="ri-logout-box-line text-lg" />
          <span className="text-sm font-medium">Déconnexion</span>
        </button>
      </div>
    </aside>
  );
}
